module.exports = __webpack_public_path__ + "img/4.6cd082a0.jpg";